import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getBaseUrl } from "../../service/apiUrl";

export const STATUSES = Object.freeze({
  IDLE: "idle",
  LOADING: "loading",
  ERROR: "error",
});

function makeKey(raceId, horseId) {
  return `${raceId}:${horseId}`;
}

export const fetchHorseHistoryForRace = createAsyncThunk(
  "/HorseHistoryForRace/fetch",
  async ({ raceId, horseId }) => {
    if (!raceId || !horseId) {
      throw new Error("raceId and horseId are required");
    }
    const res = await axios.get(
      `${getBaseUrl()}/HorseHistoryForRace/${raceId}/${horseId}`
    );
    const list = Array.isArray(res?.data?.data) ? res.data.data : (Array.isArray(res?.data) ? res.data : []);
    const turfSpeed = res?.data?.turfSpeed ?? null;
    const dirtSpeed = res?.data?.dirtSpeed ?? null;
    return { key: makeKey(raceId, horseId), list, turfSpeed, dirtSpeed };
  },
  {
    condition: ({ raceId, horseId }, { getState }) => {
      if (!raceId || !horseId) return false;
      const key = makeKey(raceId, horseId);
      const slice = getState()?.horseHistoryForRace;
      const existing = slice?.byKey?.[key];
      const status = slice?.statusByKey?.[key];
      if (status === STATUSES.LOADING) return false;
      if (status === STATUSES.ERROR) return true;
      if (Array.isArray(existing)) return false;
      return true;
    },
  }
);

const getHorseHistoryForRaceSlice = createSlice({
  name: "horseHistoryForRace",
  initialState: {
    byKey: {},
    statusByKey: {},
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchHorseHistoryForRace.pending, (state, action) => {
        const { raceId, horseId } = action.meta.arg || {};
        if (!raceId || !horseId) return;
        const key = makeKey(raceId, horseId);
        state.statusByKey[key] = STATUSES.LOADING;
      })
      .addCase(fetchHorseHistoryForRace.fulfilled, (state, action) => {
        const { key, list, turfSpeed, dirtSpeed } = action.payload || {};
        if (!key) return;
        state.byKey[key] = { list, turfSpeed, dirtSpeed };
        state.statusByKey[key] = STATUSES.IDLE;
      })
      .addCase(fetchHorseHistoryForRace.rejected, (state, action) => {
        const { raceId, horseId } = action.meta.arg || {};
        if (!raceId || !horseId) return;
        const key = makeKey(raceId, horseId);
        state.statusByKey[key] = STATUSES.ERROR;
      });
  },
});

export default getHorseHistoryForRaceSlice.reducer;

